import { RandomLayerGroupIngredientDTO } from './models/Models';

export default class IngredientProbabilityRange {
  private ingredientRow: RandomLayerGroupIngredientDTO;
  private minProbability: number;
  private maxProbability: number;

  public GetIngredient(): RandomLayerGroupIngredientDTO {
    return this.ingredientRow;
  }

  public constructor(
    ingredientRow: RandomLayerGroupIngredientDTO,
    minProbability: number,
    maxProbability: number,
  ) {
    this.ingredientRow = ingredientRow;
    this.minProbability = minProbability;
    this.maxProbability = maxProbability;
  }

  public IsInRange(probability: number): boolean {
    return probability >= this.minProbability && probability <= this.maxProbability;
  }
}
